var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"header"},[_c('div',{staticClass:"header_wrap"},[_c('LogoTxt',{on:{"btn":function($event){return _vm.$emit('btn','logo')}}}),_c('div',{staticClass:"right-menu-list"},[_c('MenuList',{on:{"btn":_vm.onMenu}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }